import React from 'react';
import { cx } from 'linaria';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';
import { theme } from '../../../Theme';

const CategoryWrapper = styled('div')`
  position: relative;
  padding-top: 77%;
  width: 100%;
  ${theme.below.md} {
    min-width: 300px;
  }
  ${theme.below.sm} {
    padding-top: 100%;
    min-width: 200px;
  }

  [data-storyblok-image-container] {
    position: absolute !important;
    top: 0;
    left: 0;
    img {
      transform: scale(1);
      transition: transform 0.5s !important;
    }
    &:hover {
      img {
        transform: scale(1.2);
      }
    }
  }
`;

const CategoryTitle = styled('span')`
  font-size: 1.5rem;
  text-align: center;
  color: white;
  position: absolute;
  bottom: 1rem;
  width: 100%;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
`;

const JournalCategory = ({ category, onClick }) => (
  <Link to={category.link} onClick={onClick}>
    <CategoryWrapper>
      <CategoryTitle>{category.title}</CategoryTitle>
    </CategoryWrapper>
  </Link>
);

export default JournalCategory;
